import { createStore } from 'vuex'

//ПРАЙС ЛИСТ

const familyLux = {adultMain:6500,adultDop:'',childMain:5500,childDop:'',single:''}

const price = [
    {
        label:'01.09.2026 - 31.10.2026',
        start:'01.09.2026',
        end:'31.10.2026',
        rooms:{
            standard:{adultMain:6600,adultDop:5400,childMain:5400,childDop:4400,single:9200},
            standardTrio:{adultMain:6600,adultDop:5400,childMain:5400,childDop:4400,single:9200},
            comfortDBL:{adultMain:6900,adultDop:5800,childMain:5800,childDop:4900,single:9600},
            comfortTWIN:{adultMain:6900,adultDop:5800,childMain:5800,childDop:4900,single:9600},
            studio:{adultMain:7500,adultDop:5900,childMain:5900,childDop:5000,single:10500},
            lux:{adultMain:9000,adultDop:6400,childMain:6400,childDop:5600,single:12000},
            familyLux,
        }
    },

    {
        label:'01.11.2026 - 27.12.2026',
        start:'01.11.2026',
        end:'27.12.2026',
        rooms:{
            standard:{adultMain:5500,adultDop:4900,childMain:4900,childDop:4400,single:8200},
            standardTrio:{adultMain:5500,adultDop:4900,childMain:4900,childDop:4400,single:8200},
            comfortDBL:{adultMain:5800,adultDop:5200,childMain:5200,childDop:4600,single:8700},
            comfortTWIN:{adultMain:5800,adultDop:5200,childMain:5200,childDop:4600,single:8700},
            studio:{adultMain:6800,adultDop:6100,childMain:6100,childDop:5400,single:10200},
            lux:{adultMain:8300,adultDop:6600,childMain:6600,childDop:4100,single:12400},
            familyLux,
        }
    },

    {
        label:'28.12.2026 - 10.01.2027',
        start:'28.12.2026',
        end:'10.01.2027',
        rooms:{
            standard:{adultMain:6500,adultDop:5800,childMain:5800,childDop:5200,single:9700},
            standardTrio:{adultMain:6500,adultDop:5800,childMain:5800,childDop:5200,single:9700},
            comfortDBL:{adultMain:6800,adultDop:6100,childMain:6100,childDop:5400,single:10200},
            comfortTWIN:{adultMain:6800,adultDop:6100,childMain:6100,childDop:5400,single:10200},
            studio:{adultMain:7800,adultDop:7000,childMain:7000,childDop:6200,single:11700},
            lux:{adultMain:9800,adultDop:7800,childMain:7800,childDop:4900,single:14700},
            familyLux,
        }
    },

    {
        label:'11.01.2027 - 31.03.2027',
        start:'11.01.2027',
        end:'31.03.2027',
        rooms:{
            standard:{adultMain:5500,adultDop:4900,childMain:4900,childDop:4400,single:8200},
            standardTrio:{adultMain:5500,adultDop:4900,childMain:4900,childDop:4400,single:8200},
            comfortDBL:{adultMain:5800,adultDop:5200,childMain:5200,childDop:4600,single:8700},
            comfortTWIN:{adultMain:5800,adultDop:5200,childMain:5200,childDop:4600,single:8700},
            studio:{adultMain:6800,adultDop:6100,childMain:6100,childDop:5400,single:10200},
            lux:{adultMain:8300,adultDop:6600,childMain:6600,childDop:4100,single:12400},
            familyLux,
        }
    }
]

import PhotoSwipeLightbox from 'photoswipe/lightbox';
import 'photoswipe/style.css';
import('photoswipe')


let lightbox = new PhotoSwipeLightbox({initialZoomLevel: 'fit', secondaryZoomLevel: 'fit', showHideAnimationType: 'fade', pswpModule: () => import('photoswipe'),});
lightbox.init();




export default createStore({
  state: {
    lightbox: lightbox,
    devMode:true,
    botAPI:'5865688161:AAE-S-baK12PQs1SSB88icAQZgvZbu_MorQ',
    notifyChats:['16667793'],
    lightBoxSource:undefined,
    debug:false,
    enterPoint:undefined,
    mobileMenuShow:false,
    ui:{
      narrow:false,
      colors: undefined,
      size:{
        scrollbarWidth:5,
        contentMaxWidth:1200,
        mobileNav:60,
        navPanel:{
          desktop:90,
          mobile:0
        },
        text:{
          title:16,
          subtitle:14,
          main:12,
          sm:10,
          xs:8,
        }
      }
    },
    dictionary:{
      date:{
        days:["Понедельник", "Вторник", "Среда", "Четверг", "Пятница", "Суббота", "Воскресение"],
        days_short:["ПН", "ВТ", "СР", "ЧТ", "ПТ", "СБ", "ВС"],
        months: ["Январь", "Февраль", "Март", "Апрель", "Май", "Июнь", "Июль", "Август", "Сентябрь", "Октябрь", "Ноябрь", "Декабрь"]
      },
    },
    screen:{
      width:undefined,
      height:undefined,
      startHeight:undefined,
      orientation:undefined,
      device:undefined,
      scrollY:0,
      contentOffset:undefined,
      scrollYbeforeLock:0,
      scrollX:0,
      menuStickyPoint:false,
    },
    temp:{},
    currentRoute:'main',
    bookingRoom:'standard',
    activePromoId: null,
    returnToModalAfterPromo: null,
    promoIsActive: false,
    rooms: {
      standard:{
        alias:'standard',
        name:'Стандарт-Твин',
        rooms:'Однокомнатный',
        floor:'ЛАМИНАТ',
        size:16,
        guests:'2 ГОСТЯ',
        description:'Классический двухместный номер «СТАНДАРТ - ТВИН». Номера этой категории расположены в первом корпусе.',
        facilities: ['twoSingleBed','shower','fan','robe', 'tea','minibar','wifi','tv'],
      },
      standardTrio:{
        alias:'standardTrio',
        name:'Стандарт-Трио',
        rooms:'Однокомнатный',
        floor:'ЛАМИНАТ',
        size:16,
        guests:'3 ГОСТЯ',
        description:'Трёхместный номер «СТАНДАРТ - ТРИО». Номера этой категории расположены в первом корпусе.',
        facilities: ['twoSingleBed','shower','fan','robe', 'tea','minibar','wifi','tv'],
      },
      comfortTWIN:{
        alias:'comfort',
        name:'Комфорт-ТВИН',
        rooms:'Однокомнатный',
        floor:'ЛАМИНАТ',
        size:20,
        guests:'2 ГОСТЯ + 2 ДОП. МЕСТА',
        description:'Улучшенный двухместный номер «КОМФОРТ». Номера этой категории расположены во втором корпусе.',
        facilities: ['twoSingleBed','oneSofa','shower','tea','robe','fan','minibar','wifi','tv'],
      },
      comfortDBL:{
        alias:'comfortDBL',
        name:'Комфорт-ДАБЛ',
        rooms:'Однокомнатный',
        floor:'ЛАМИНАТ',
        size:20,
        guests:'2 ГОСТЯ + 2 ДОП. МЕСТА',
        description:'Улучшенный двухместный номер «КОМФОРТ». Номера этой категории расположены во втором корпусе.',
        facilities: ['oneDoubleBed','oneSofa','shower','tea','robe','fan','minibar','wifi','tv'],
      },
      lux:{
        name:'Люкс',
        alias:'lux',
        rooms:'Двухкомнатный',
        floor:'ЛАМИНАТ',
        size:35,
        guests:'2 ГОСТЯ + 2 ДОП. МЕСТА',
        description:'Просторный двухкомнатный номер «ЛЮКС». Номера этой категории расположены во втором корпусе.',
        facilities: ['oneDoubleBed','oneSofa','bath','tea','robe','fan','minibar','wifi','tv'],
      },
      familyLux:{
        name:'Семейный Люкс',
        alias:'familyLux',
        rooms:'Двухкомнатный',
        floor:'ЛАМИНАТ',
        size:45,
        guests:'4 ГОСТЯ',
        description:'Большой двухкомнатный  номер «СЕМЕЙНЫЙ ЛЮКС». Номера этой категории расположены во втором корпусе.',
        facilities: ['oneDoubleBed', 'twoSingleBed', 'bath','tea','robe','fan','minibar','wifi','tv'],
      },
      studio:{
        alias:'studio',
        name:'Студио',
        rooms:'Однокомнатный',
        floor:'ЛАМИНАТ',
        size:22,
        guests:'2 ГОСТЯ + 2 ДОП. МЕСТА',
        description:'Просторный двухместный номер «СТУДИО». Номера этой категории расположены в первом корпусе.',
        facilities: ['oneDoubleBed','oneSofa','shower','tea','robe','fan','minibar','wifi','tv'],
      }
    },
    galleries:{
      rooms:{}
    },
    facilities:{
      oneSingleBed:{icon:'bed-single', name:'1 ОДНОСПАЛЬНАЯ КРОВАТЬ'},
      twoSingleBed:{icon:'bed-single', name:'2 ОДНОСПАЛЬНЫЕ КРОВАТИ'},
      oneDoubleBed:{icon:'bed-double', name:'ДВУСПАЛЬНАЯ КРОВАТЬ'},
      oneSofa:{icon:'sofa', name:'ДИВАН-КРОВАТЬ'},
      twoSofa:{icon:'sofa', name:'2 ДИВАНА-КРОВАТИ'},
      bath:{icon:'bath', name:'СОБСТВЕННАЯ ВАННА'},
      shower:{icon:'shower', name:'ДУШ'},
      fan:{icon:'fan', name:'ФЕН'},
      tea:{icon:'hot-cup', name:'ЧАЙНЫЙ НАБОР'},
      towel:{icon:'towel', name:'ПОЛОТЕНЦА'},
      minibar:{icon:'minibar', name:'ХОЛОДИЛЬНИК'},
      tv:{icon:'tv', name:'ТВ'},
      wifi:{icon:'wifi', name:'WI-FI'},
      floorCarpet:{icon:'floor', name:'КОВРОЛИН'},
      floorWood:{icon:'floor', name:'ЛАМИНАТ'},
      robe:{icon:'robe', name:'ХАЛАТЫ'},

    },
    modals:{
      ModalMobileMenu:false,
      ModalRules:false,
      ModalDocs:false,
      ModalContacts:false,
      ModalCovid:false,
      ModalPartners:false,
      ModalReservation:false,
      ModalMedRules:false,
      ModalMedPersonal:false,
      ModalMedPaidService:false,
      ModalMedPrice:false,
      ModalRoomPrice:false,
      ModalPromo:false,
    },
    overlayReady:false,
    overlayLock:false,
    cookieConsentStatus: null,
    price:price,
    minPrice:{}
  },
  getters: {},
  mutations: {
    bookFromPrice(state){
      state.modals.ModalRoomPrice = false
      state.modals.ModalBooking = true
    },
    updateMinPrice(state){
      let minPrice={
        standard:state.price[0].rooms.standard.adultMain,
        standardTrio:state.price[0].rooms.standardTrio.adultMain,
        comfortTWIN:state.price[0].rooms.comfortTWIN.adultMain,
        comfortDBL:state.price[0].rooms.comfortDBL.adultMain,
        studio:state.price[0].rooms.studio.adultMain,
        lux:state.price[0].rooms.lux.adultMain,
        familyLux:state.price[0].rooms.familyLux.adultMain
      }

      state.minPrice = minPrice

    },
    setOverlayReady(state){state.overlaReady = true},
    setEnterPoint(state,route){state.enterPoint = route},
    updateColors(state,colors){state.ui.colors = colors},
    updateBookingRoom(state,room){
      state.bookingRoom = room
    },
    updateScroll(state,offset){
      //ОБНОВЛЕНИЕ ТЕКУЩЕГО ПОЛОЖЕНИЕ SCROLL ПО ВЕРТИКАЛИ
      if(offset){state.screen.scrollY=offset;
      if(state.screen.scrollY>=state.screen.height+1){state.screen.menuStickyPoint=true}else{state.screen.menuStickyPoint=false}}
    },
    updateScreen(state){
      // ОПРЕДЕЛЕНИЕ РАЗМЕРОВ ОКНА, ТИПА УСТРОЙСТВА И ОРИЕНТАЦИИ ЭКРАНА
      const width = window.innerWidth; state.screen.width = window.innerWidth
      const height = window.innerHeight; state.screen.height = window.innerHeight
      if(state.screen.startHeight===undefined){state.screen.startHeight=height}
      let narrowState = state.ui.narrow
      let device = 'desktop'; let orientation = 'landscape';if(width<height){orientation = 'portrait'}
      if(width<1000){device='tablet'} if(width<700){device='mobile'}
      if(state.screen.orientation !== orientation){state.screen.orientation = orientation; if(state.devMode && state.debug){console.log(`Ориентация экрана изменилась на - ${orientation}`)}}
      if(state.screen.device !== device){state.screen.device = device; if(state.devMode && state.debug){console.log(`Тип устройства изменилась на - ${device}`)}}
      state.screen.orient= orientation

      let narrow
      if(width<state.ui.size.contentMaxWidth){narrow = true; this.commit('updateTextSize')}else{narrow=false}
      if(narrowState !== narrow){
        state.ui.narrow = !state.ui.narrow
        if(!narrow){
          if(state.temp.textSize){state.ui.size.text = Object.assign({}, state.temp.textSize)}
        }
      }

    },
    updateTextSize(state){
      if(!state.temp.textSize){state.temp.textSize=Object.assign({}, state.ui.size.text)}
      let difSize =((state.ui.size.contentMaxWidth-state.screen.width)/state.screen.width)*100
      let textSizeVariables = Object.keys(state.ui.size.text)
      textSizeVariables.forEach(t=>{
        state.ui.size.text[t] = state.temp.textSize[t] * (1 - difSize / 100)
      })
    },
    updateRoute(state,route){state.currentRoute = route},
    setActivePromo(state, id){state.activePromoId = id},
    openPromoFromRoomPrice(state, promoId){
      if(!state.promoIsActive) return
      state.activePromoId = promoId
      state.returnToModalAfterPromo = 'ModalRoomPrice'
      state.modals.ModalRoomPrice = false
      state.modals.ModalPromo = true
    },
    toggleOverlay(state,overlay){
      state.overlayLock = !state.overlayLock
      state.overlays[overlay]=!state.overlays[overlay]
      if(state.screen.scrollYbeforeLock>state.screen.height){
        document.getElementById('Nav').style.position='absolute'
        document.getElementById('Nav').style.width='100%'
        document.getElementById('Nav').style.top=state.screen.scrollYbeforeLock+'px'
      }
    },
    openModal(state,modal) {
      state.screen.scrollYbeforeLock = state.screen.scrollY
      document.getElementById('OverlaysView').style.top='0px'
      document.getElementById('OverlaysView').style.zIndex='1000'
      state.overlayLock = true
      state.modals[modal] = true
    },
    closeModal(state,modal){
      state.modals[modal] = false
      if(modal === 'ModalPromo' && state.returnToModalAfterPromo){
        const returnTo = state.returnToModalAfterPromo
        state.returnToModalAfterPromo = null
        state.activePromoId = null
        state.modals[returnTo] = true
        return
      }
      state.overlayLock = false
      setTimeout(()=>{document.getElementById('OverlaysView').style.zIndex='0';},300)
    },
    loadCookieConsent(state) {
      const cookieConsentKey = 'san-elita-cookie-consent'
      const stored = localStorage.getItem(cookieConsentKey)

      if (stored === 'accepted' || stored === 'rejected') {
        state.cookieConsentStatus = stored
        return
      }

      if (stored === '1') {
        state.cookieConsentStatus = 'accepted'
        localStorage.setItem(cookieConsentKey, 'accepted')
        return
      }

      state.cookieConsentStatus = null
    },
    acceptCookieConsent(state) {
      state.cookieConsentStatus = 'accepted'
      localStorage.setItem('san-elita-cookie-consent', 'accepted')
    },
    rejectCookieConsent(state) {
      state.cookieConsentStatus = 'rejected'
      localStorage.setItem('san-elita-cookie-consent', 'rejected')
    },
  },
  actions: {
    scrollToContent(){document.getElementById('showContent').scrollTo({top: document.getElementById('contentStart').offsetTop, behavior: 'smooth'})},
    showLightBox(state,{images,imageIndex}){
      let sIndex = 0; if(imageIndex){sIndex=imageIndex}
      lightbox.loadAndOpen(sIndex,images)
    }
  },
  modules: {}
})
